var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10525_87862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 24.5V31.5C37 32.4283 36.6313 33.3185 35.9749 33.9749C35.3185 34.6313 34.4283 35 33.5 35H9C8.07174 35 7.1815 34.6313 6.52513 33.9749C5.86875 33.3185 5.5 32.4283 5.5 31.5V24.5",
    stroke: "#1F1F1F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3107 2.43934C21.7249 1.85355 20.7751 1.85355 20.1893 2.43934L11.4393 11.1893C10.8536 11.7751 10.8536 12.7249 11.4393 13.3107C12.0251 13.8964 12.9749 13.8964 13.5607 13.3107L19.75 7.12132V24.5C19.75 25.3284 20.4216 26 21.25 26C22.0784 26 22.75 25.3284 22.75 24.5V7.12132L28.9393 13.3107C29.5251 13.8964 30.4749 13.8964 31.0607 13.3107C31.6464 12.7249 31.6464 11.7751 31.0607 11.1893L22.3107 2.43934Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10525_87862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.fdff1464fc96d725d54d15b879986dca.svg";
export { ForwardRef as ReactComponent };